// extracted by mini-css-extract-plugin
export default {"connectButton":"ConnectSocialNetworkButton_connectButton__mmywx"};